/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';

/*Import Requisição API*/
import api from '../../../../api';
import { formatadorCNPJ, formatadorCPF, formatadorNumeroCelular, formatarCpfCnpj, validadorCNPJ, validadorCPF, validadorEmail } from '../../../../utils/Validadores';

export default function EditarFornecedor() {

    const [usuario_id, setIdUsuario] = useState();
    const [nome, setNome] = useState();
    const [cpf_cnpj, setCpfCnpj] = useState();
    const [telefone, setTelefone] = useState();
    const [email, setEmail] = useState();
    const [site, setSite] = useState();
    const [contatoNome, setContatoNome] = useState();
    const [contatoEmail, setContatoEmail] = useState();
    const [razaoSocial, setRazaoSocial] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [inscricaoMunicipal, setInscricaoMunicipal] = useState('');
    const [statusFornecedor, setStatusFornecedor] = useState('Ativo');

    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');

    const [texto, setTexto] = useState('');
    const [modalAberto, setModalAberto] = useState(false);
    const [errors, setErrors] = useState({ cpfCnpj: '', telefone: '', email: '' });
    const caixaDeDialogo = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const id_fornecedor = location.state?.id;

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const buscarEnderecoPorCep = async (cep) => {
        if (cep.length !== 8) {
            setTexto('Por favor, insira um CEP válido com 8 dígitos.');
            mostrarModal();
            return;
        }
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                setTexto('CEP não encontrado.');
                mostrarModal();
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
            }
        } catch (error) {
            console.error('Erro ao buscar endereço:', error);
            setTexto('Erro ao buscar o endereço. Tente novamente mais tarde.');
            mostrarModal();
        }
    };

    const mascaraCep = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/(\d{5})(\d{3})/, '$1-$2')
            .slice(0, 9);
    };

    const handleNumericInput = (e) => {
        const charCode = e.which || e.keyCode;
        if (charCode < 48 || charCode > 57) {
            e.preventDefault();
        }
    };

    const handleCpfCnpjChange = (e) => {
        const value = e.target.value;
        const formattedValue = formatarCpfCnpj(value);
        setCpfCnpj(formattedValue);

        const rawValue = value.replace(/\D/g, '');
        if (rawValue.length === 11 && !validadorCPF(rawValue)) {
            setErrors((prev) => ({ ...prev, cpfCnpj: 'CPF inválido!' }));
        } else if (rawValue.length === 14 && !validadorCNPJ(rawValue)) {
            setErrors((prev) => ({ ...prev, cpfCnpj: 'CNPJ inválido!' }));
        } else {
            setErrors((prev) => ({ ...prev, cpfCnpj: '' }));
        }
    };

    const handleTelefoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        let formattedValue;

        if (value.length <= 10) {
            formattedValue = value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
        } else {
            formattedValue = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
        }
        setTelefone(formattedValue);

        if (value.length < 10 || value.length > 11) {
            setErrors((prev) => ({ ...prev, telefone: 'Telefone inválido!' }));
        } else {
            setErrors((prev) => ({ ...prev, telefone: '' }));
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        if (value && !validadorEmail(value)) {
            setErrors((prev) => ({ ...prev, email: 'Email inválido!' }));
        } else {
            setErrors((prev) => ({ ...prev, email: '' }));
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);

                if (response.data.success) {
                    console.log('Passei aqui');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    const validarDados = () => {
        if (!nome) return 'O nome é obrigatório.';
        if (!cpf_cnpj) return 'O CPF ou CNPJ é obrigatório.';
        if (cpf_cnpj.length <= 11 && !validadorCPF(cpf_cnpj)) return 'CPF inválido.';
        if (cpf_cnpj.length > 11 && !validadorCNPJ(cpf_cnpj)) return 'CNPJ inválido.';
        if (!telefone || telefone.length < 10) return 'O telefone deve ter pelo menos 10 dígitos.';
        if (!email || !validadorEmail(email)) return 'E-mail inválido.';
        if (!cep) return 'O CEP é obrigatório.';
        if (!logradouro) return 'O logradouro é obrigatório.';
        if (!numero) return 'O número é obrigatório.';
        if (!bairro) return 'O bairro é obrigatório.';
        if (!cidade) return 'A cidade é obrigatória.';
        if (!estado) return 'O estado é obrigatório.';
        return null;
    };

    useEffect(() => {
        const carregarDadosFornecedor = async () => {
            try {
                const response = await api.get(`/fornecedores/${id_fornecedor}`);
                const { fornecedor } = response.data;
                console.log(fornecedor)

                if (fornecedor) {
                    setNome(fornecedor.nome || '');
                    setCpfCnpj(formatarCpfCnpj(fornecedor.cpf_cnpj) || '');
                    setTelefone(formatadorNumeroCelular(fornecedor.telefone) || '');
                    setEmail(fornecedor.email || '');
                    setSite(fornecedor.site || '');
                    setContatoNome(fornecedor.contato_nome || '');
                    setContatoEmail(fornecedor.contato_email || '');
                    setRazaoSocial(fornecedor.razao_social || '');
                    setInscricaoEstadual(fornecedor.inscricao_estadual || '');
                    setInscricaoMunicipal(fornecedor.inscricao_municipal || '');
                    setStatusFornecedor(fornecedor.status_fornecedor || 'Ativo');

                    const endereco = fornecedor.endereco || {};
                    setLogradouro(endereco.logradouro || '');
                    setNumero(endereco.numero || '');
                    setComplemento(endereco.complemento || '');
                    setBairro(endereco.bairro || '');
                    setCidade(endereco.cidade || '');
                    setEstado(endereco.estado || '');
                    setCep(endereco.cep || '');
                } else {
                    console.error('Fornecedor não encontrado.');
                }
            } catch (error) {
                console.error('Erro ao carregar dados do fornecedor:', error);
            }
        };

        if (id_fornecedor) {
            carregarDadosFornecedor();
        }
    }, [id_fornecedor]);

    const enviarEdicaoFornecedor = async (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const erroValidacao = validarDados();
        const telefoneLimpo = telefone.replace(/\D/g, '');
        const cpfCnpjLimpo = cpf_cnpj.replace(/\D/g, '');

        if (erroValidacao) {
            alert(erroValidacao);
            return;
        }

        const fornecedor = {
            nome,
            cpf_cnpj: cpfCnpjLimpo,
            telefone: telefoneLimpo,
            email,
            site,
            contato_nome: contatoNome,
            contato_email: contatoEmail,
            razao_social: razaoSocial || null,
            inscricao_estadual: inscricaoEstadual || null,
            inscricao_municipal: inscricaoMunicipal || null,
            status_fornecedor: statusFornecedor,
        };

        const endereco = {
            cep,
            logradouro,
            numero,
            complemento,
            bairro,
            cidade,
            estado,
            tipo: 'Comercial',
        };

        setLoading(true);
        try {
            await api.put(`/fornecedores/${id_fornecedor}`, { fornecedor, endereco, usuario_id });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            navigate('/menu/fornecedores');
        } catch (error) {
            console.error('Erro ao editar o fornecedor:', error);
            alert('Erro ao tentar atualizar o fornecedor.');
        } finally {
            setLoading(false);
        }
    };

    const preencherCampos = () => {
        setNome('Fornecedor Exemplo');
        setCpfCnpj('12345678000195');
        setTelefone('11999999999');
        setEmail('fornecedor@exemplo.com');
        setSite('www.exemplo.com');
        setContatoNome('João Silva');
        setContatoEmail('contato@exemplo.com');

        setCep('12345678');
        setLogradouro('Rua Exemplo');
        setNumero('123');
        setComplemento('Apto 45');
        setBairro('Bairro Exemplo');
        setCidade('São Paulo');
        setEstado('SP');
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'e') {
                e.preventDefault();
                preencherCampos();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleCpfOuCnpjChange = (e) => {
        const { value } = e.target;
        const sanitizedValue = value.replace(/\D/g, '');

        let valorFormatado = sanitizedValue;

        if (sanitizedValue.length <= 11) {
            valorFormatado = formatadorCPF(sanitizedValue);
        } else if (sanitizedValue.length <= 14) {
            valorFormatado = formatadorCNPJ(sanitizedValue);
        }

        setCpfCnpj(valorFormatado);
    };


    return (
        <section className='container-principal-editar-fornecedor'>
            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button id="botao" onClick={fecharModal}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>
            <Cabecalho />

            <CookieAceite />

            <main>

                <MenuLateral />

                <section className='conteudo-editar-fornecedor'>

                    <div className='titulo-perfil'>
                        <h1><span>Fornecedores</span> &gt; Editar Fornecedor</h1>
                    </div>

                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <div className='perfil-editar-fornecedor'>
                        <h2>Digite os dados do Fornecedor</h2>
                        <form className='form-editar-fornecedor' onSubmit={enviarEdicaoFornecedor}>

                            <label className='lasbel-nome'>Nome: <span className='span-obrigatorio'>*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o nome do fornecedor"
                                />
                            </div>

                            <label className="label-cnpj">
                                CPF ou CNPJ: <span className="span-obrigatorio">*</span>
                            </label>
                            <div className="input-cnpj">
                                <input
                                    type="text"
                                    value={cpf_cnpj}
                                    onChange={handleCpfOuCnpjChange}
                                    placeholder="Digite o CPF ou CNPJ"
                                />
                            </div>

                            <label className="label-telefone">
                                Telefone: <span className="span-obrigatorio">*</span>
                            </label>
                            <div className="input-telefone">
                                <input
                                    type="text"
                                    value={telefone}
                                    onChange={handleTelefoneChange}
                                    onKeyPress={handleNumericInput}
                                    placeholder="Digite o telefone"
                                />
                            </div>

                            <label className="label-email">
                                Email: <span className="span-obrigatorio">*</span>
                            </label>
                            <div className="input-email">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    placeholder="Digite seu email"
                                />
                            </div>

                            <label className='lasbel-site'>Site:</label>
                            <div className="input-site">
                                <input
                                    type="text"
                                    value={site}
                                    onChange={(e) => setSite(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o site (Opcional)"
                                />
                            </div>
                            <label className='lasbel-nomeContato'>Nome para Contato:</label>
                            <div className="input-nomeContato">
                                <input
                                    type="text"
                                    value={contatoNome}
                                    onChange={(e) => setContatoNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o para Contato (Opcional)"
                                />
                            </div>
                            <label className='lasbel-emailContato'>Email para Contato:</label>
                            <div className="input-emailContato">
                                <input
                                    type="email"
                                    value={contatoEmail}
                                    onChange={(e) => setContatoEmail(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o e-mail para contato (Opcional)"
                                />
                            </div>

                            <label className='lasbel-razaoSocial'>Razão Social:</label>
                            <div className="input-razaoSocial">
                                <input
                                    type="text"
                                    value={razaoSocial}
                                    onChange={(e) => setRazaoSocial(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite a razão social"
                                />
                            </div>

                            <label className='lasbel-inscricaoEstadual'>Inscrição Estadual (IE):</label>
                            <div className="input-inscricaoEstadual">
                                <input
                                    type="text"
                                    value={inscricaoEstadual}
                                    onChange={(e) => setInscricaoEstadual(e.target.value)}
                                    maxLength={20}
                                    placeholder="Digite a inscrição estadual"
                                />
                            </div>

                            <label className='lasbel-inscricaoMunicipal'>Inscrição Municipal (IM):</label>
                            <div className="input-inscricaoMunicipal">
                                <input
                                    type="text"
                                    value={inscricaoMunicipal}
                                    onChange={(e) => setInscricaoMunicipal(e.target.value)}
                                    maxLength={20}
                                    placeholder="Digite a inscrição municipal"
                                />
                            </div>

                            <label>Status do Fornecedor:</label>
                            <div className="input-statusFornecedor">
                                <select value={statusFornecedor} onChange={(e) => setStatusFornecedor(e.target.value)}>
                                    <option value="Ativo">Ativo</option>
                                    <option value="Inativo">Inativo</option>
                                    <option value="Bloqueado">Bloqueado</option>
                                </select>
                            </div>

                            <div className='linha-1-endereco'>
                                <div className='conteudo-cep'>
                                    <label className='lasbel-cep'>CEP: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-cep'>
                                        <input
                                            type="text"
                                            value={cep}
                                            onChange={(e) => setCep(mascaraCep(e.target.value))}
                                            onBlur={() => buscarEnderecoPorCep(cep.replace(/\D/g, ''))}
                                            maxLength={8}
                                            placeholder="Digite o CEP"
                                        />
                                    </div>
                                </div>

                                <div className='conteudo-numero'>
                                    <label className='lasbel-numero'>Número: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-numero'>
                                        <input
                                            type="text"
                                            value={numero}
                                            onChange={(e) => setNumero(e.target.value)}
                                            placeholder="Digite o Nº"
                                        />
                                    </div>
                                </div>
                            </div>

                            <label>Logradouro:</label>
                            <div className='input-logradouro'>
                                <input
                                    type="text"
                                    value={logradouro}
                                    onChange={(e) => setLogradouro(e.target.value)}
                                    placeholder="Logradouro"
                                    disabled
                                />
                            </div>

                            <label>Bairro:</label>
                            <div className='input-bairro'>
                                <input
                                    type="text"
                                    value={bairro}
                                    onChange={(e) => setBairro(e.target.value)}
                                    placeholder="Bairro"
                                    disabled
                                />
                            </div>

                            <div className='linha-5-endereco'>
                                <div className='conteudo-cidade'>
                                    <label className='lasbel-cidade'>Cidade:</label>
                                    <div className='input-cidade'>
                                        <input
                                            type="text"
                                            value={cidade}
                                            onChange={(e) => setCidade(e.target.value)}
                                            placeholder="Cidade"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className='conteudo-estado'>
                                    <label className='label-estado'>Estado:</label>
                                    <div className='input-estado'>
                                        <input
                                            type="text"
                                            value={estado}
                                            onChange={(e) => setEstado(e.target.value)}
                                            maxLength={2}
                                            placeholder="Estado"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <label>Complemento:</label>
                            <div className='input-complemento'>
                                <input
                                    type="text"
                                    value={complemento}
                                    onChange={(e) => setComplemento(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o complemento (Opcional)"
                                />
                            </div>

                            <button className='bnt-editar-fornecedor' type="submit">Editar Fornecedor</button>
                        </form>
                    </div>
                    )}

                </section>
            </main >

            <Rodape />

        </section >
    );
}
